import {BuyBonusPopUpEvents, KeypadControlsEvents, WinMeterEvents, WinPresentationModule} from '@gongxigames/framework/slot';
import {GameWinPresentationView} from 'src/winPresentation/GameWinPresentationView';

export class GameWinPresentationModule extends WinPresentationModule {
    public get view(): GameWinPresentationView {
        return this._view as GameWinPresentationView;
    }

    protected setupEvents(): void {
        super.setupEvents();
        this.on(BuyBonusPopUpEvents.BUY_BUTTON_CLICKED, this.onBuyButtonClicked);
    }

    protected onBuyButtonClicked(): void {
        if (this.currentState.name !== WinPresentationModule.BASIC_STATE) {
            this.gotoState(WinPresentationModule.BASIC_STATE);
            this.onWinMeterFinished();
            this.eventManager.emit(WinMeterEvents.STOP);
            this.view.stop();
        }
    }

    protected onBetChanged(): void {
        this.currentState.handle(KeypadControlsEvents.TOTAL_BET_CHANGED);

        if (this.currentState.name !== WinPresentationModule.BASIC_STATE) {
            this.gotoState(WinPresentationModule.BASIC_STATE);
        }
        this.onWinMeterFinished();
        this.eventManager.emit(WinMeterEvents.STOP);
        this.view.stop();
    }
}
